// appsignal.js
import Appsignal from '@appsignal/javascript'
import { plugin } from `@appsignal/plugin-window-events`

export function appsignal(namespace) {
  const appsignal = new Appsignal({
    key: APPSIGNAL_FRONTEND_API_KEY,
    revision: GITHUB_RUN_NUMBER,
    namespace,
    ignoreErrors: [
      //https://hatchjs.com/resizeobserver-loop-completed-with-undelivered-notifications/
      /ResizeObserver loop completed with undelivered notifications/,
      /Constructor for "cookie-consent-banner#undefined" was not found/,
      /The <text> hyperscript tag can only contain text content as children./,
      /The operation is insecure./
    ],
  })

  appsignal.use(plugin())

  return appsignal
}
